<script lang="ts">
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import GatewayG3MainControl from 'src/components/DevicesSettings/VirtualComponents/BluTRV/GatewayG3MainControl.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<DeviceViewStateWrapper {device}>
	<div slot="content">
		<GatewayG3MainControl {device} />
	</div>
</DeviceViewStateWrapper>
